
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../helper/api";
import { setCookies } from "../../helper/utils";
import { toast } from "react-toastify";

export const login = createAsyncThunk("user/login", async (payload) => {
  const response = await api.post("admin/login", payload);
  console.log("login ")
  return response;
});

const loginSlice = createSlice({
  name: "user",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
       
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        
        setCookies('token', action.payload.data.data.token)
        setCookies('role', action.payload.data.data.role)
       
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(login.rejected, (state, action) => {
       
        state.loading = false;
        state.error = action.error.message;
        toast.error(action.error.message);
      });
  },
});

export default loginSlice.reducer;
